/**
 * Cookie de presencia de sesión (espejo en cliente junto a `onAuthStateChanged` en `useAuth`).
 * Útil para herramientas o futuros hosts con SSR; con `output: 'export'` el acceso se regula en
 * `AlumniSessionRouteGuard` y guards por ruta, no vía middleware de Next.
 * No se persiste el ID token en cookies: evita exponer el JWT (XSS). Los custom claims vía Firebase en cliente.
 */
export const AUTH_SESSION_COOKIE = 'alumni_auth_session'

/** Nombre de cookie legada; se borra al iniciar sesión para no dejar JWT antiguos. */
const LEGACY_ALUMNI_ID_TOKEN_COOKIE = 'alumni_id_token'

/** ~14 días, alineado con refresco típico de sesión Firebase en cliente */
export const AUTH_SESSION_MAX_AGE_SEC = 60 * 60 * 24 * 14

function buildSessionCookie(value: string, maxAgeSec: number): string {
	if (typeof document === 'undefined') return ''
	const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : ''
	return `${AUTH_SESSION_COOKIE}=${value}; Path=/; Max-Age=${maxAgeSec}; SameSite=Lax${secure}`
}

function buildLegacyIdTokenClearCookie(): string {
	if (typeof document === 'undefined') return ''
	const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : ''
	return `${LEGACY_ALUMNI_ID_TOKEN_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`
}

export function setAuthSessionCookie(): void {
	if (typeof document === 'undefined') return
	document.cookie = buildSessionCookie('1', AUTH_SESSION_MAX_AGE_SEC)
}

/** Elimina la cookie legada que contenía el JWT (versiones anteriores del front). */
export function clearLegacyAlumniIdTokenCookie(): void {
	if (typeof document === 'undefined') return
	document.cookie = buildLegacyIdTokenClearCookie()
}

/** Debe usar los mismos atributos que al crear (p. ej. Secure en HTTPS) o el navegador no la borra. */
export function clearAuthSessionCookie(): void {
	if (typeof document === 'undefined') return
	document.cookie = buildSessionCookie('', 0)
	clearLegacyAlumniIdTokenCookie()
}
